import { Component, OnInit } from "@angular/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { ModalController, ToastController } from "@ionic/angular";

@Component({
  selector: "app-view-image-only",
  templateUrl: "./view-image-only.component.html",
})
export class ViewImageOnlyComponent implements OnInit {
  base64: string;
  imageSrc: any;
  documentName: string;
  fileName: string;

  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController
  ) {}

  ngOnInit(): void {
    console.log('base64', this.base64);
    const byteArray = new Uint8Array(
      atob(this.base64)
        .split("")
        .map((char) => char.charCodeAt(0))
    );
    let blob = new Blob([byteArray], { type: "image/png" });
    this.imageSrc = URL.createObjectURL(blob);
  }

  async downloadPdf() {
    let platform = localStorage.getItem("platform");
    if (platform == "android" || platform == "ios") {
      try {
        let ret = await Filesystem.mkdir({
          path: "ihlms",
          directory: Directory.Documents,
          recursive: false,
        });
        console.log("folder ", ret);
      } catch (e) {
        console.log("Folder already exists");
      }

      await Filesystem.writeFile({
        path: "ihlms/" + this.fileName,
        data: "data:image/png;base64," + this.base64,
        directory: Directory.Documents,
      });

      const toast = await this.toastController.create({
        message: this.fileName + " Downloaded in Documents folder",
        icon: "information-circle",
        position: "top",
        cssClass: "toast success-toast",
        duration: 2000,
      });
      toast.present();
    } else {
      window.open(this.imageSrc, "_blank");
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
